/*=========================================================================================
  File Name: moduleImmoMutations.js
  Description: Immo Module Mutations
==========================================================================================*/


export default {
  SET_SEARCH_PARAMS(state, payload) {
    state.search = payload;
  },
  SET_ISBACK_TOSEARCH(state, payload) {
    state.search.isBackToSearch = payload;
  },
};